/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { IconButton, Box, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { selectSnackBarSuccess } from '../../store/snackBar/snackBarSelector';
import { useDispatch, useSelector } from 'react-redux';
import { hideSnackbar } from '../../store/snackBar/snackBarActionCreator';

export interface ISnackbarAlert {
  showSnackbar: boolean;
  autoHideDuration?: number;
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
}
const SnackbarAlert: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const selectSucccessMessage = useSelector(selectSnackBarSuccess);
  const { severity, message, showSnackbar, autoHideDuration } = selectSucccessMessage

  const handleClose = (event?: any, reason?: string) => {
    if (event !== null && reason === 'clickaway') {
      return;
    }
    dispatch(hideSnackbar());
  };
  const action = (
    <IconButton color="inherit" aria-label="Close Icon Button" onClick={handleClose}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );
  return (
    <Box>
      {severity === 'error' ? (
        <Snackbar
          id="snackbar-component"
          open={showSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          onClose={handleClose}
        >
          <Alert id="snackbar-alert-component" elevation={2} variant="filled" severity={severity} action={action}>
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          id="snackbar-component"
          open={showSnackbar}
          autoHideDuration={autoHideDuration}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          onClose={handleClose}
        >
          <Alert id="snackbar-alert-component" elevation={2} variant="filled" severity={severity}>
            {message}
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
};

export default SnackbarAlert;
